import * as React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { SmsOutlined, WarningOutlined } from '@mui/icons-material';
import { useSendPhoneVerificationQuery } from '../store/apis';
import { toast } from 'react-toastify';
import { IEmployee, IUser } from '../models';

interface PhoneVerifiedProps {
  user: IUser | IEmployee;
}

export const PhoneVerified: React.FC<PhoneVerifiedProps> = (props) => {
  const { user } = props;

  const [verifyPhoneButtonDisabled, setVerifyPhoneButtonDisabled] = React.useState(false);
  const [skipSendPhoneVerificationLoading, setSkipSendPhoneVerificationLoading] = React.useState<boolean>(true);
  const { data: phoneVerificationData, isLoading: sendPhoneVerificationLoading } = useSendPhoneVerificationQuery(
    { userId: user?.id },
    { skip: skipSendPhoneVerificationLoading },
  );
  React.useEffect(() => {
    if (!sendPhoneVerificationLoading) {
      setSkipSendPhoneVerificationLoading(true);
    }

    if (phoneVerificationData) {
      setVerifyPhoneButtonDisabled(true);
      toast.success(<Msg />);
    }
  }, [sendPhoneVerificationLoading, phoneVerificationData]);

  const Msg = () => (
    <Box>
      <Typography variant="body2">Phone verification request sent successfully.</Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        marginTop: 1,
      }}
    >
      <Typography variant="body2" color="primary" sx={{ display: 'flex', alignItems: 'center' }}>
        <WarningOutlined sx={{ marginRight: 1 }} /> Phone number is not verified!
      </Typography>
      <Button
        disabled={verifyPhoneButtonDisabled}
        startIcon={
          sendPhoneVerificationLoading ? (
            <CircularProgress
              color="inherit"
              size={14}
              sx={{
                marginRight: 0.8,
              }}
            />
          ) : (
            <SmsOutlined />
          )
        }
        onClick={() => setSkipSendPhoneVerificationLoading(false)}
      >
        Verify Phone
      </Button>
    </Box>
  );
};
